import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";

// Styles
import { useStyles } from "../CreateLeague";

// Components
import { PointCell, PointHead, RankHead } from "../../LeagueTableComponents";

// Actions
import {
  addPointSystemAction,
  listAllPointSystem,
  updatePointSystemAction,
} from "../../../../redux/actions/league-action";

const addPointSystemObj = { system_name: "", points_description: [] };

var rowsP1 = [],
  rowsP2 = [],
  rowsP3 = [],
  rowsP4 = [],
  rowsP5 = [];

for (var i = 1; i <= 20; i++) rowsP1.push(i);
for (var i = 21; i <= 40; i++) rowsP2.push(i);
for (var i = 41; i <= 60; i++) rowsP3.push(i);
for (var i = 61; i <= 80; i++) rowsP4.push(i);
for (var i = 81; i <= 100; i++) rowsP5.push(i);

const POTYFields = ({ leagueData, handleFieldChange }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // == Selectors == 
  const pointSystemList = useSelector((state) => state.listPointSystemReducer);
  // Selector for updating point system
  const editPointSystem = useSelector((state) => state.updatePointSystemReducer);
  // Selector for Creating point system
  const createPointSystem = useSelector(
    (state) => state.createPointSystemReducer
  );

  // Local States
  const [editablePointSystem, setEditablePointSystem] = useState(false);
  const [addPointSystem, setAddPointSystem] = useState(addPointSystemObj);

  const handleFillValues = (value, rank) => {
    setAddPointSystem((prev) => {
      return {
        ...prev,
        points_description: [...prev.points_description].map((n) => {
          if (n.rank == rank) return { ...n, value };
          else return n;
        }),
      };
    });
  };

  const handleCreateInitialPointSystem = () => {
    const initialPS = [];
    for (let i = 0; i < 100; i++) initialPS.push({ rank: i + 1, value: "" });

    return initialPS;
  };

  const handleAdd = (addPointSystem) => {
    const payloadPointSystem = { ...addPointSystem };
    dispatch(addPointSystemAction(payloadPointSystem));
  };

  const handleEdit = (editPointSystem) => {
    const payloadPointSystem = { ...editPointSystem };
    dispatch(updatePointSystemAction(payloadPointSystem, leagueData.pointsystemID));
  }

  const handleAddPointSystem = () => {
    const { system_name, points_description } = addPointSystem;

    const hasAllValuesFilled = points_description.every((item) => item.value);

    if (leagueData.pointsystemID != "") {
      const targettedPointList = pointSystemList?.data?.pointsystems?.filter(
        (pl) => pl._id == leagueData.pointsystemID
      );
      const { system_name: systemName } = targettedPointList[0];

      if (systemName == system_name && hasAllValuesFilled) handleEdit(addPointSystem)
      else handleAdd(addPointSystem);

    } else {
      if (system_name != "" && hasAllValuesFilled) handleAdd(addPointSystem);
    }
  };

  useEffect(() => {
    if (leagueData.pointsystemID == "") {
      const initPS = handleCreateInitialPointSystem();
      setAddPointSystem((prev) => ({ ...prev, points_description: initPS }));
    }
  }, []);

  useEffect(() => {
    if (leagueData.pointsystemID != "") {
      const x = pointSystemList?.data?.pointsystems?.filter(
        (pl) => pl._id == leagueData.pointsystemID
      );

      if (x?.length) {
        const { points_description, system_name } = x[0];
        setAddPointSystem({ system_name, points_description });
      }
    }
  }, [leagueData]);

  useEffect(() => {
    if (!createPointSystem?.loading && createPointSystem?.data) {
      handleFieldChange(createPointSystem.data.pointsystemID, "pointsystemID")
      setEditablePointSystem(false);
      dispatch(listAllPointSystem());
    }
  }, [createPointSystem])

  useEffect(() => {
    if (!createPointSystem?.loading && !createPointSystem?.data?.error) {
      setEditablePointSystem(false);
      dispatch(listAllPointSystem());
    }
  }, [editPointSystem])

  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          Point System
        </InputLabel>

        <Box display="flex">
          <Select
            sx={{ flex: 1 }}
            name="pointsystemID"
            variant="outlined"
            value={leagueData.pointsystemID}
            className={classes.textFieldStyles}
            onChange={(e) => handleFieldChange(e.target.value, "pointsystemID")}
          >
            {pointSystemList?.data &&
              pointSystemList?.data?.pointsystems?.map((item) => (
                <MenuItem key={item?._id} value={item?._id}>
                  {item?.system_name}
                </MenuItem>
              ))}
          </Select>

          {editablePointSystem ? (
            <Button
              variant="filled"
              className={classes.btn}
              onClick={() => setEditablePointSystem(false)}
            >
              Cancel
            </Button>
          ) : (
            <Button
              variant="filled"
              className={classes.btn}
              onClick={() => setEditablePointSystem(true)}
            >
              Edit
            </Button>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <Table size="small">
          <TableBody sx={{ border: "1px solid #7D7D7D" }}>
            <TableRow>
              <RankHead />

              {rowsP1.map((x) => (
                <TableCell className={classes.cellStyle}>{x}</TableCell>
              ))}
            </TableRow>

            <TableRow>
              <PointHead />

              {rowsP1.map((rank, i) => {
                return (
                  <TableCell
                    className={classes.cellStyle}
                    sx={{ padding: `${editablePointSystem && 0}` }}
                  >
                    {editablePointSystem ? (
                      <PointCell
                        name="value"
                        editable={editablePointSystem ? true : false}
                        value={
                          addPointSystem.points_description[rank - 1]?.value
                        }
                        onChange={(e) => handleFillValues(e.target.value, rank)}
                      />
                    ) : (
                      <span>
                        {addPointSystem.points_description[rank - 1]?.value}
                      </span>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        </Table>

        <Table size="small" sx={{ mt: 2 }}>
          <TableBody sx={{ border: "1px solid #7D7D7D" }}>
            <TableRow>
              <RankHead />

              {rowsP2.map((x) => (
                <TableCell className={classes.cellStyle}>{x}</TableCell>
              ))}
            </TableRow>

            <TableRow>
              <PointHead />

              {rowsP2.map((rank, i) => (
                <TableCell
                  className={classes.cellStyle}
                  sx={{ padding: `${editablePointSystem && 0}` }}
                >
                  {editablePointSystem ? (
                    <PointCell
                      sx={{ textAlign: "center", background: "yellow" }}
                      name="value"
                      editable={editablePointSystem ? true : false}
                      value={addPointSystem.points_description[rank - 1]?.value}
                      onChange={(e) => handleFillValues(e.target.value, rank)}
                    />
                  ) : (
                    <>{addPointSystem.points_description[rank - 1]?.value}</>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>

        <Table size="small" sx={{ mt: 2 }}>
          <TableBody sx={{ border: "1px solid #7D7D7D" }}>
            <TableRow>
              <RankHead />

              {rowsP3.map((x) => (
                <TableCell className={classes.cellStyle}>{x}</TableCell>
              ))}
            </TableRow>

            <TableRow>
              <PointHead />

              {rowsP3.map((rank, i) => (
                <TableCell
                  className={classes.cellStyle}
                  sx={{ padding: `${editablePointSystem && 0}` }}
                >
                  {editablePointSystem ? (
                    <PointCell
                      name="value"
                      editable={editablePointSystem ? true : false}
                      value={addPointSystem.points_description[rank - 1]?.value}
                      onChange={(e) => handleFillValues(e.target.value, rank)}
                    />
                  ) : (
                    <>{addPointSystem.points_description[rank - 1]?.value}</>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>

        <Table size="small" sx={{ mt: 2 }}>
          <TableBody sx={{ border: "1px solid #7D7D7D" }}>
            <TableRow>
              <RankHead />

              {rowsP4.map((x) => (
                <TableCell className={classes.cellStyle}>{x}</TableCell>
              ))}
            </TableRow>

            <TableRow>
              <PointHead />

              {rowsP4.map((rank, i) => (
                <TableCell
                  className={classes.cellStyle}
                  sx={{ padding: `${editablePointSystem && 0}` }}
                >
                  {editablePointSystem ? (
                    <PointCell
                      name="value"
                      editable={editablePointSystem ? true : false}
                      value={addPointSystem.points_description[rank - 1]?.value}
                      onChange={(e) => handleFillValues(e.target.value, rank)}
                    />
                  ) : (
                    <>{addPointSystem.points_description[rank - 1]?.value}</>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>

        <Table size="small" sx={{ mt: 2 }}>
          <TableBody sx={{ border: "1px solid #7D7D7D" }}>
            <TableRow>
              <RankHead />

              {rowsP5.map((x) => (
                <TableCell className={classes.cellStyle}>{x}</TableCell>
              ))}
            </TableRow>

            <TableRow>
              <PointHead />

              {rowsP5.map((rank, i) => (
                <TableCell
                  className={classes.cellStyle}
                  sx={{ padding: `${editablePointSystem && 0}` }}
                >
                  {editablePointSystem ? (
                    <PointCell
                      name="value"
                      editable={editablePointSystem ? true : false}
                      value={addPointSystem.points_description[rank - 1]?.value}
                      onChange={(e) => handleFillValues(e.target.value, rank)}
                    />
                  ) : (
                    <>{addPointSystem.points_description[rank - 1]?.value}</>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </Box>

      {editablePointSystem && (
        <>
          <InputLabel className={classes.inputLableStyles}>
            New Point System Name
          </InputLabel>

          <Box display="flex">
            <TextField
              name="system_name"
              sx={{ flex: 1 }}
              variant="outlined"
              className={classes.textFieldStyles}
              value={addPointSystem.system_name}
              onChange={(e) =>
                setAddPointSystem((prev) => ({
                  ...prev,
                  system_name: e.target.value,
                }))
              }
            />

            <Button
              variant="filled"
              className={classes.btn}
              onClick={handleAddPointSystem}
            >
              Save
            </Button>
          </Box>
        </>
      )}
    </>
  );
};

export default POTYFields;
